/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiApplicationCreateRequest } from '../models/ApiApplicationCreateRequest'
import type { ApiApplicationIndexResource } from '../models/ApiApplicationIndexResource'
import type { ApiApplicationResource } from '../models/ApiApplicationResource'
import type { ApiApplicationUpdateRequest } from '../models/ApiApplicationUpdateRequest'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class ApiApplicationsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * View all API applications
     * @returns any OK
     * @throws ApiError
     */
    public apiAuthApplicationsIndex(): CancelablePromise<{
        data: Array<ApiApplicationIndexResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api-auth/applications',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create new API Application
     * @returns any Created
     * @throws ApiError
     */
    public apiAuthApplicationsCreate({
        requestBody
    }: {
        requestBody?: ApiApplicationCreateRequest
    }): CancelablePromise<{
        data: ApiApplicationResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api-auth/applications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * View single API application
     * @returns any OK
     * @throws ApiError
     */
    public apiAuthApplicationsShow({
        uuid
    }: {
        /**
         * UUID of the retrieved resource.
         */
        uuid: string
    }): CancelablePromise<{
        data: ApiApplicationResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api-auth/applications/{uuid}',
            path: {
                uuid: uuid
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete an API Application
     * @returns void
     * @throws ApiError
     */
    public apiAuthApplicationsDestroy({
        uuid
    }: {
        /**
         * UUID of the retrieved resource.
         */
        uuid: string
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api-auth/applications/{uuid}',
            path: {
                uuid: uuid
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update an existing API Application
     * @returns any OK
     * @throws ApiError
     */
    public apiAuthApplicationsUpdate({
        uuid,
        requestBody
    }: {
        /**
         * UUID of the retrieved resource.
         */
        uuid: string
        requestBody?: ApiApplicationUpdateRequest
    }): CancelablePromise<{
        data: ApiApplicationResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api-auth/applications/{uuid}',
            path: {
                uuid: uuid
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public apiAuthUsage({
        start,
        end,
        endpoint,
        application,
        token
    }: {
        /**
         * The start date of the usage data. Defaults to 1 week ago.
         */
        start?: string
        /**
         * The end date of the usage data. Defaults to now.
         */
        end?: string
        /**
         * Fetch data for specific endpoint. Cannot mix with application and token filters.
         */
        endpoint?: string
        /**
         * Fetch data for specific application. Cannot mix with endpoint and token filters.
         */
        application?: string
        /**
         * Fetch data for specific token ID. Cannot mix with endpoint and application filters.
         */
        token?: number
    }): CancelablePromise<{
        data: Record<string, number>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api-auth/usage',
            query: {
                start: start,
                end: end,
                endpoint: endpoint,
                application: application,
                token: token
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
